import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneVersamentoResultComponent } from './conservazione-versamento-result';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-versamento-result', {
            url: '/verifica-documenti-caricati-result',
            ncyBreadcrumb: {
                label: 'Verifica Documenti Caricati',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Verifica Documenti Caricati'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-versamento-result flex="100"></conservazione-versamento-result>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneVersamentoResultModule: string = ng
    .module('conservazione-versamento-result', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneVersamentoResult', ConservazioneVersamentoResultComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-versamento-result/conservazione-versamento-result.module.ts